/* eslint-disable max-len */

import React from 'react';
import LocationFull from '../../../icons/location';
import './styles.scss';

const Point = ({description, date, index, last, indexCurrent, nextDate}) => {
  return (
    <div className='fl-timeline-customer-item-container'>
      <div className="fl-timeline-customer-point-container fl-timeline-customer-location">
        {!nextDate && date ? <LocationFull color={'#2185d0'}/> : <div className='fl-empty-location' />}
      </div>
      <div className='fl-timeline-customer-point-container'>
        {index === 0 ? (
          <div className='fl-timeline-customer-line'>
            <h4 className='fl-timeline-title'>FECHAS</h4>
          </div>
        ) : (
          <hr className={`fl-timeline-customer-line
          ${index === 0 ? 'fl-timeline-line-transparent' : 'fl-timeline-line-grey'}
          `} />
        )
        }

        <div className={`
          fl-timeline-customer-circle
          ${date ? 'fl-timeline-selected' : 'fl-timeline-empty'}
          fl-timeline-border-grey
          `}>
        </div>
        {index === last ? (
          <div className='fl-timeline-customer-line' />
        ) : (
          <hr className={`fl-timeline-customer-line
          ${index === last ? 'fl-timeline-line-transparent' : 'fl-timeline-line-grey'}
          `} />
        )
        }
      </div>
      <div className='fl-timeline-customer-text-container'>
        <div className='title-custom-fl-timeline-name' size='tiny'>{description}</div>
        <div
          className={`${date ? 'title-custom-fl-timeline-date' : 'title-custom-fl-timeline-date-empty'}`}
          size='tiny'
        >
          {date?.substring(0, 10) || 'N/D'}
        </div>
      </div>
    </div>
  );
};

const TimeLine = ({data}) => {
  let indexCurrent = -1;
  const dataLength = data?.length;
  return (
    <div className='fl-timeline-customer-container'>
      {data?.map((item, index) => {
        if (item.date) {
          indexCurrent = index;
        }
        const nextDate = index >= dataLength - 1 ? null : data[index + 1]?.date;
        return (
          <>
            <Point
              description={item.description}
              date={item.date}
              nextDate={nextDate}
              index={index}
              indexCurrent={indexCurrent}
              last = {dataLength - 1}
            />
          </>
        );
      }
      )}
    </div>
  );
};

export default TimeLine;
